import React, { useState, useRef } from "react";
import { manageEnvelopeDocFormStatusUpdate } from "../../../../../services/CommonService";
import { toast } from "react-toastify";
import Utils from "../../../../../utils";

function ApproveRejectSignDoc(props) {
  const [chooseButton, setChooseButton] = useState(0);
  const [reason, setReason] = useState("");
  const [errors, setErrors] = useState({ reason: "" });
  const clsApproveRejectSignDocRef = useRef(null);

  const hideApproveRejectSignDoc = (e) => {
    e.preventDefault();
    props.setSignDocDetail({
      id: 0,
      envelope_id: 0,
      recipient_id: 0,
      is_call: false,
      sign_doc_detail: {},
    });
    setReason("");
    setChooseButton(0);
  };

  const handleDownload = async (e, obj) => {
    e.preventDefault();
    props.setLoading(true);
    await Utils.downloadAnyFile(obj.file_path, obj.file_name);
    props.setLoading(false);
  };

  const handleAcceptRejectSignDoc = async (e, type) => {
    e.preventDefault();

    let errorObj = { reason: "" };
    let error = false;
    if (type === 2 && !reason) {
      errorObj.reason = "Please enter reason";
      error = true;
    }
    setErrors(errorObj);
    if (error) return;

    props.setLoading(true);
    let ipAddress = "";
    await Utils.getIpAddress().then((response) => {
      ipAddress = response;
    });

    const obj = {
      id: props.signDocDetail?.id,
      envelope_id: props.signDocDetail?.envelope_id,
      recipient_id: props.signDocDetail?.recipient_id,
      entity_type: 3,
      reason: type === 2 ? reason : "",
      status: type === 1 ? 3 : 4, // 3 = Approved, 4 = Rejected
      ip_address: ipAddress,
    };

    manageEnvelopeDocFormStatusUpdate(obj)
      .then((response) => {
        let dataList = { ...props.docFormList };
        let sList = [...props.statusList];
        let signDocumentList = dataList.sign_doc_list || [];

        const index = signDocumentList.findIndex(
          (x) => parseInt(x.id) === parseInt(props.signDocDetail.id)
        );

        if (index > -1) {
          // Update selected document status
          signDocumentList[index]["status_id"] = type === 1 ? 3 : 4;

          // Recalculate counts
          let awaiting = 0;
          let needReview = 0;
          let approved = 0;
          let rejected = 0;

          for (let i = 0; i < signDocumentList.length; i++) {
            const status = parseInt(signDocumentList[i]["status_id"]);
            if (status === 1) awaiting++;
            else if (status === 2) needReview++;
            else if (status === 3) approved++;
            else if (status === 4) rejected++;
          }

          // ✅ Add safe check before looping form_list
          if (dataList?.form_list?.length > 0) {
            for (let i = 0; i < dataList.form_list.length; i++) {
              const status = parseInt(dataList.form_list[i]["status_id"]);
              if (status === 1) awaiting++;
              else if (status === 2) needReview++;
              else if (status === 3) approved++;
              else if (status === 4) rejected++;
            }
          }

          // ✅ Update status totals correctly
          for (let i = 1; i <= 4; i++) {
            const idx = sList.findIndex((x) => parseInt(x.id) === i);
            if (idx > -1) {
              if (i === 1) sList[idx]["total"] = awaiting;
              else if (i === 2) sList[idx]["total"] = needReview;
              else if (i === 3) sList[idx]["total"] = approved;
              else if (i === 4) sList[idx]["total"] = rejected;
            }
          }

          // ✅ Refresh sign document list based on active filter
          const activeStatus = sList.find((x) => x.active === true);
          if (activeStatus) {
            if (parseInt(activeStatus.id) === 0) {
              props.setSignDocList(signDocumentList);
            } else {
              const filteredList = signDocumentList.filter(
                (doc) =>
                  parseInt(doc.status_id) === parseInt(activeStatus.id)
              );
              props.setSignDocList(filteredList);
            }
          }

          props.setStatusList(sList);
          dataList.sign_doc_list = signDocumentList;
          props.setDocFormList(dataList);
        }

        clsApproveRejectSignDocRef?.current.click();
        props.setLoading(false);
        toast.success(response.data.message);
      })
      .catch((err) => {
        props.setLoading(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  return (
    <div
      className="offcanvas offcanvas-end ManageDocument"
      data-bs-scroll="true"
      tabIndex="-1"
      data-bs-keyboard="false"
      data-bs-backdrop="static"
      id="ApproveRejectSignDoc"
      aria-labelledby="ApproveRejectSignDocLabel"
    >
      <div className="offcanvas-header">
        <h5 className="offcanvas-title" id="ApproveRejectSignDocLabel">
          Contract - Manage
        </h5>
        <button
          type="button"
          className="btn close_btn text-reset"
          data-bs-dismiss="offcanvas"
          ref={clsApproveRejectSignDocRef}
          onClick={hideApproveRejectSignDoc}
          aria-label="Close"
        >
          <i className="bi bi-x-circle" aria-hidden="true" />
        </button>
      </div>

      <div className="offcanvas-body">
        <h5 className="offcanvas-title text_blue mb-1 fw-bold">
          Contract Received
        </h5>
        <div className="card mb-3">
          <div className="d-flex flexWrap align-items-center justify-content-between mb-3">
            <h5 className="offcanvas-title mx-3 text_black">File Received</h5>
            <span
              className={`${
                props?.signDocDetail?.sign_doc_detail?.status_id === 1
                  ? `bg_light_blue`
                  : props?.signDocDetail?.sign_doc_detail?.status_id === 2
                  ? `bg_light_yellow`
                  : props?.signDocDetail?.sign_doc_detail?.status_id === 3
                  ? `bg_light_green`
                  : `bg_light_ping`
              } d-block`}
            >
              {props?.signDocDetail?.sign_doc_detail?.status_id === 1
                ? `Awaiting to Sign`
                : props?.signDocDetail?.sign_doc_detail?.status_id === 2
                ? `Needs Review`
                : props?.signDocDetail?.sign_doc_detail?.status_id === 3
                ? `Approved`
                : `Rejected`}
            </span>
          </div>

          {props?.signDocDetail?.sign_doc_detail?.upload_file_list?.map(
            (item, index) => (
              <h2
                key={index}
                className="request_document_tab mb-3 position-relative w-auto"
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div className="accordion_text text_blue w-auto">
                    {item.file_name}
                    {item.is_upload_client === 1 && (
                      <i
                        className="bi bi-x-circle ms-2 text-black cur-pointer"
                        aria-hidden="true"
                      />
                    )}
                  </div>
                  <div className="d-flex">
                    <span
                      className="cur-pointer"
                      onClick={(e) => handleDownload(e, item)}
                    >
                      <i className="bi bi-download round_blue" aria-hidden="true" />
                    </span>
                  </div>
                </div>
              </h2>
            )
          )}

          {props?.signDocDetail?.sign_doc_detail?.notes && (
            <div className="rejected_note bg_offwhite mb-3">
              <p>{props?.signDocDetail?.sign_doc_detail?.notes}</p>
              <span className="side_image">
                <img src="/images/note.webp" alt="..." />
              </span>
            </div>
          )}
        </div>

        <h5 className="offcanvas-title text_blue mb-1 fw-bold">
          Contract Requested
        </h5>
        <div className="accordion mx-lg-3 mb-3" id="Sign_Document_medicard">
          <div className="accordion-item">
            <h2 className="accordion-header" id="SignMedicareRejected">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#Sign-Medicare-Rejected"
                aria-expanded="true"
                aria-controls="Sign-Medicare-Rejected"
              >
                {props?.signDocDetail?.sign_doc_detail?.doc_name}
              </button>
            </h2>
            <div
              id="Sign-Medicare-Rejected"
              className="accordion-collapse collapse show"
              aria-labelledby="SignMedicareRejected"
              data-bs-parent="#Sign_Document_medicard"
            >
              <div className="accordion-body">
                <p className="mb-3 p_tag">
                  {props?.signDocDetail?.sign_doc_detail?.doc_detail}
                </p>
                <div className="download_document">
                  {props?.signDocDetail?.sign_doc_detail?.file_list?.map(
                    (item, index) => (
                      <span
                        key={index}
                        onClick={(e) => handleDownload(e, item)}
                        className="download_box text_blue section-bg-color w-100 border-0"
                      >
                        {item.file_name}
                        <i
                          className="bi bi-download ms-3 round_blue"
                          aria-hidden="true"
                        />
                      </span>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {props?.signDocDetail?.sign_doc_detail?.status_id > 1 && (
          <>
            {chooseButton === 2 && (
              <div className="reject_btn_input mx-3 text-center d-block">
                <textarea
                  className={`form-control ${
                    errors.reason ? "" : "mb-3"
                  }`}
                  rows="2"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="Type Rejection Note"
                />
                {errors.reason && (
                  <div className="text-danger mb-3">{errors.reason}</div>
                )}
                <button
                  type="button"
                  className="btn btn-outline-secondary rounded-5"
                  onClick={() => setChooseButton(0)}
                >
                  <i className="bi bi-chevron-left me-2" /> Back
                </button>
                <button
                  type="button"
                  onClick={(e) => handleAcceptRejectSignDoc(e, 2)}
                  className="btn btn-danger RejectButton ms-3"
                >
                  <i className="fa fa-check-square me-2" /> Reject
                </button>
              </div>
            )}

            {chooseButton === 0 && (
              <div className="modal-footer approve_reject border-top py-2">
                {props?.signDocDetail?.sign_doc_detail?.status_id === 2 && (
                  <>
                    <button
                      type="button"
                      className="btn btn-primary approve_btn"
                      onClick={(e) => handleAcceptRejectSignDoc(e, 1)}
                    >
                      <i className="bi bi-check-circle" /> Approve
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary reject_btn"
                      onClick={() => setChooseButton(2)}
                    >
                      <i className="bi bi-x-circle" /> Reject
                    </button>
                  </>
                )}

                {props?.signDocDetail?.sign_doc_detail?.status_id === 4 && (
                  <>
                    <button
                      type="button"
                      className="btn btn-primary approve_btn"
                      onClick={(e) => handleAcceptRejectSignDoc(e, 1)}
                    >
                      <i className="bi bi-check-circle" /> Approve
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger cur-no-drop reject_btn"
                    >
                      <i className="bi bi-x-circle" /> Rejected
                    </button>
                  </>
                )}

                {props?.signDocDetail?.sign_doc_detail?.status_id === 3 && (
                  <>
                    <button
                      type="button"
                      className="btn btn-success cur-no-drop approve_btn"
                    >
                      <i className="bi bi-check-circle" /> Approved
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger reject_btn"
                      onClick={() => setChooseButton(2)}
                    >
                      <i className="bi bi-x-circle" /> Reject
                    </button>
                  </>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default ApproveRejectSignDoc;
